import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, CircularProgress, Typography, Container, Paper, Box } from '@mui/material';
import PageLayout from '../components/PageLayout';
import { useAuth } from '../context/AuthContext';
import { fetchActiveUserAuctions } from '../services/auctions';

function HomePage() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [navigating, setNavigating] = useState(false);

    const handleNavigate = async () => {
        if (!user) {
            navigate('/champions-league');
            return;
        }

        // Alleen actieve veilingen (seizoen niet afgerond) tellen mee. Heeft de
        // gebruiker er geen, dan gaat hij naar de pagina om te joinen of te starten.
        setNavigating(true);
        try {
            const { managed, participating } = await fetchActiveUserAuctions(user.uid);
            const all = [...new Set([...participating, ...managed].map((a) => a.id))];

            if (all.length === 0) {
                navigate('/champions-league');
            } else if (participating.length === 1 && managed.length === 0) {
                navigate(`/auction/${participating[0].id}/my-team`);
            } else {
                navigate('/my-auctions');
            }
        } catch (err) {
            console.error('Kon de veilingen niet bepalen:', err);
            navigate('/my-auctions');
        } finally {
            setNavigating(false);
        }
    };

    return (
        <PageLayout>
            <Container component="main" maxWidth="sm">
                <Paper
                    elevation={6}
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: 4
                    }}
                >
                    <Typography component="h1" variant="h4" gutterBottom>
                        Champions League veiling
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph align="center">
                        Ga de strijd aan met jouw vrienden en koop de beste spelers van de Champions League in.
                    </Typography>
                    <Box sx={{ mt: 3, width: '100%' }}>
                        <Button
                            onClick={handleNavigate}
                            variant="contained"
                            fullWidth
                            size="large"
                            disabled={navigating}
                            startIcon={navigating ? <CircularProgress size={20} color="inherit" /> : null}
                        >
                            Ga naar spel
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </PageLayout>
    );
}

export default HomePage;
